import { execOnLoad } from '../../scripts/helpers';
import './info-bar.scss';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import breakpoints from 'breakpoints';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initInfoBar = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  if (window.innerWidth >= parseInt(breakpoints.lg)) {
    const stickyElement = sectionContainer.querySelector(
      '.info-bar__container',
    );
    const main = document.querySelector('main');
    if (!stickyElement || !main) return;

    gsap.registerPlugin(ScrollTrigger);

    gsap.to(stickyElement, {
      scrollTrigger: {
        trigger: sectionContainer,
        start: 'bottom bottom',
        endTrigger: main,
        end: 'bottom bottom',
        pin: true,
        pinSpacing: false,
        onEnter: () => (sectionContainer.style.zIndex = '1000'),
        onLeave: () => (sectionContainer.style.display = 'none'),
        onUpdate: (self) => {
          if (self.isActive) {
            sectionContainer.style.zIndex = '1000';
          }
        },
      },
    });
  }
};

execOnLoad(window.dAgency.initInfoBar, '.info-bar__section');
